import { globalData } from ".."

const DEFAULT_COLORS = {
    closeIconBackgroundColor: '#ff77a8',
    closeIconColor: '#000',
    bodyBackgroundColor: '#fff',
    messagesBackgroundColor: '#5200c4',
    messagesFontColor: '#d8c1f0',
    ctaBackgroundColor: '#e5358e',
    ctaFontColor: '#fff',
    soundIconColor: '#e5358e'
}


//PROCESS THE COLOR PARAMS IF THEY ARE EXIST IN THE DEFAUL OBJECT AND ARE AN HTML COLOR CODE
const colorProcess = () => {

    const colorRegex = new RegExp(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)

    for (const key in globalData) {

        const value = globalData[key]

        //ONLY SET HEADER BACKGROUND IF IT EXISTS FROM THE CMS, IF NOT USE THE BODY
        if (key === 'headerBackgroundColor' && value) {
            DEFAULT_COLORS.headerBackgroundColor = value
        }

        if (DEFAULT_COLORS[key] && colorRegex.test(value)) {

            DEFAULT_COLORS[key] = value;
        }
    }

}

export { DEFAULT_COLORS, colorProcess }